module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/Q-e9668d809b295dc5c876b7b7dfb7d496.png";